/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:768px){.error-card[_ngcontent-%COMP%]{padding:24px}}.error-code[_ngcontent-%COMP%]{font-size:20rem;font-weight:700;color:#2d323e}.error-message[_ngcontent-%COMP%]{font-size:4rem;font-weight:700;color:#2d323e;padding-bottom:10rem}"];
export { styles as styles };
